@if (print && filter) {
<app-print-filter-data [filter]="filter" />
}@if(data.length){
<div class="button-right">
    <button class="btn danger__no-bg" (click)="exportToExcel()">
        Exportar em Excel
    </button>
</div>

<br />
@for (reservation of data; track $index) {
<app-reservation-card [reservation]="reservation" />
}
} @else {
<div class="empty">
    <p>Não há dados para exibir</p>
</div>
}